export const defaultMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  s1: 'h5',
  s2: 'h5',
  s3: 'h6',
  s4: 'h6',
  b0: 'p',
  b1: 'p',
  b2: 'p',
  b3: 'p',
  b4: 'p',
  b5: 'p',
  b6: 'p',
};
